// extracted by mini-css-extract-plugin
module.exports = {"form":"IncomeForm_form__2iv4k","noteField":"IncomeForm_noteField__3g9y3","formButton":"IncomeForm_formButton__1yae_"};